module.exports = __webpack_public_path__ + "img/horizontal_6_5_pp3_0.55a501e0.png";